export default __webpack_public_path__ + "static/media/activated_sim.2362cc92.png";